module.exports = __webpack_public_path__ + "img/aboutus-photo-2-pc.b39a8c62.png";